import { render, staticRenderFns } from "./HouseTypeList.vue?vue&type=template&id=ca4fc110"
import script from "./HouseTypeList.vue?vue&type=script&lang=js"
export * from "./HouseTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports